import { FC } from 'react'
import { InputAdornment, makeStyles, TextField } from '@perk-ui/core'
import { Search } from 'react-feather'

export interface PatientTableSearch {
  searchValue: string
  setSearchValue: (value: string) => void
  customClassName?: string
  customPlaceholder?: string
}

const useStyles = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(3),
    paddingLeft: 0,
    width: theme.spacing(65),
  },
  icon: {
    marginLeft: theme.spacing(1.5),
    width: theme.spacing(4),
    marginRight: theme.spacing(-2.5),
    color: theme.palette.grey[600],
  },
}))

const PatientTableSearch: FC<PatientTableSearch> = ({
  setSearchValue,
  searchValue,
  customClassName,
  customPlaceholder,
}) => {
  const classes = useStyles()

  return (
    <TextField
      className={customClassName ? customClassName : classes.textField}
      placeholder={customPlaceholder ? customPlaceholder : 'Search'}
      onChange={(e) => setSearchValue(e.target.value)}
      value={searchValue}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search className={classes.icon} />
          </InputAdornment>
        ),
      }}
    />
  )
}

export default PatientTableSearch
